var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.02 0a11 11 0 1 1 0 22.02 11 11 0 0 1 0-22.02zm5.43 7.7l-2.13-2.13-3.3 3.3-3.3-3.3L5.58 7.7l3.3 3.3-3.3 3.3 2.12 2.13 3.3-3.3 3.31 3.3 2.13-2.12-3.3-3.3 3.3-3.3zM11.02 3a8 8 0 1 1 0 16 8 8 0 0 1 0-16z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.cef8a3a2a19b140730824751f9e08b43.svg";
export { ForwardRef as ReactComponent };